export default __webpack_public_path__ + "static/media/houseupper.92725d33.jpg";